import { render, staticRenderFns } from "./create-balance.vue?vue&type=template&id=6c6f2eec&scoped=true"
import script from "./create-balance.vue?vue&type=script&lang=js"
export * from "./create-balance.vue?vue&type=script&lang=js"
import style0 from "./create-balance.vue?vue&type=style&index=0&id=6c6f2eec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6f2eec",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/create-balance.vue
// module id = 4tJi
// module chunks = 0